"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dropzone_1 = require("react-dropzone");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const complete_check_svg_1 = __importDefault(require("images/utility-icons/complete_check.svg"));
const garbage_icon_svg_1 = __importDefault(require("images/utility-icons/garbage-icon.svg"));
const utils_1 = require("utils");
function StoreDocUploadForm({ store, uploadDocument, uploadCallback, }) {
    const [myFilesBankingProof, setMyFilesBankingProof] = (0, react_1.useState)([]);
    const [myFilesEntity, setMyFilesEntity] = (0, react_1.useState)([]);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const [submitted, setSubmitted] = (0, react_1.useState)(false);
    const [localFileResponse, setLocalFileResponse] = (0, react_1.useState)(null);
    const [localBankResponse, setLocalBankResponse] = (0, react_1.useState)(null);
    const [errFileEntity, setErrFileEntity] = (0, react_1.useState)(null);
    const [errFileBanking, setErrFileBanking] = (0, react_1.useState)(null);
    const onDropBankingProof = (0, react_1.useCallback)((acceptedFiles) => {
        setMyFilesBankingProof([...myFilesBankingProof, ...acceptedFiles]);
    }, [myFilesBankingProof]);
    const onDropEntity = (0, react_1.useCallback)((acceptedFiles) => {
        setMyFilesEntity([...myFilesEntity, ...acceptedFiles]);
    }, [myFilesEntity]);
    const MAX_FILENAME = 2000;
    const MULTI_FILE = false;
    const MAX_FILES = 1;
    const MAX_SIZE = 20000000;
    const ACCEPT_TYPES = {
        'application/pdf': ['.pdf'],
        'image/png': ['.png'],
        'image/jpg': ['.jpg'],
        'image/jpeg': ['.jpeg'],
    };
    const checkFile = (file) => {
        let tmpErrMsg = null;
        if (file.size > MAX_SIZE) {
            tmpErrMsg = {
                code: 'file-too-large',
                message: `File is larger than ${MAX_SIZE / 1000000}MB, select a smaller file`,
            };
        }
        if (!ACCEPT_TYPES[file.type]) {
            tmpErrMsg = {
                code: 'invalid-file-type',
                message: 'Invalid file type',
            };
        }
        if (String(file.name).split('').length > MAX_FILENAME) {
            tmpErrMsg = {
                code: 'name-too-large',
                message: `Name is larger than ${MAX_FILENAME} characters`,
            };
        }
        return tmpErrMsg;
    };
    const handleBankingValidation = (file) => {
        const tmpErrMsg = checkFile(file);
        if (tmpErrMsg) {
            (0, utils_1.toastError)(tmpErrMsg.message, 3000);
            setErrFileBanking(tmpErrMsg.message);
        }
        else {
            setErrFileBanking(null);
        }
        return tmpErrMsg;
    };
    const handleEntityValidation = (file) => {
        const tmpErrMsg = checkFile(file);
        if (tmpErrMsg) {
            (0, utils_1.toastError)(tmpErrMsg.message, 3000);
            setErrFileEntity(tmpErrMsg.message);
        }
        else {
            setErrFileEntity(null);
        }
        return tmpErrMsg;
    };
    const { acceptedFiles: acceptedFilesBankingProof, getRootProps: getRootPropsBankingProof, getInputProps: getInputPropsBankingProof, isDragReject: isDragRejectBankingProof, isDragAccept: isDragAcceptBankingProof, } = (0, react_dropzone_1.useDropzone)({
        accept: ACCEPT_TYPES,
        maxFiles: MAX_FILES,
        maxSize: MAX_SIZE,
        multiple: MULTI_FILE,
        onDrop: onDropBankingProof,
        validator: handleBankingValidation,
    });
    const { acceptedFiles: acceptedFilesEntity, getRootProps: getRootPropsEntity, getInputProps: getInputPropsEntity, isDragReject: isDragRejectEntity, isDragAccept: isDragAcceptEntity, } = (0, react_dropzone_1.useDropzone)({
        accept: ACCEPT_TYPES,
        maxFiles: MAX_FILES,
        maxSize: MAX_SIZE,
        multiple: MULTI_FILE,
        onDrop: onDropEntity,
        validator: handleEntityValidation,
    });
    const filesBankingProof = acceptedFilesBankingProof.map((file) => ((0, jsx_runtime_1.jsxs)("li", { children: [file.path, " - ", file.size, " bytes"] }, file.path)));
    const filesEntity = acceptedFilesEntity.map((file) => ((0, jsx_runtime_1.jsxs)("li", { children: [file.path, " - ", file.size, " bytes"] }, file.path)));
    const removeAllBankingProof = () => {
        setMyFilesBankingProof([]);
    };
    const removeAllEntity = () => {
        setMyFilesEntity([]);
    };
    const handleSubmit = async () => {
        setSubmitting(true);
        try {
            let upBankDocResp = null;
            let upFileDocResp = null;
            if (myFilesBankingProof.length) {
                upBankDocResp = await uploadDocument({
                    file: myFilesBankingProof[0],
                    name: myFilesBankingProof[0].name,
                    content: 'location_banking_proof',
                });
            }
            if (myFilesEntity.length) {
                upFileDocResp = await uploadDocument({
                    file: myFilesEntity[0],
                    name: myFilesEntity[0].name,
                    content: 'location_entity_proof',
                });
            }
            if (upBankDocResp) {
                setLocalBankResponse(upBankDocResp);
            }
            if (upFileDocResp) {
                setLocalFileResponse(upFileDocResp);
            }
        }
        catch (error) {
        }
        finally {
            setSubmitted(true);
            setSubmitting(false);
        }
    };
    const isPristine = () => {
        let needBanking = true;
        let needEntity = true;
        if (!store.bankingChanged ||
            !!myFilesBankingProof.length ||
            !store.needsBankingFileUpload) {
            needBanking = false;
        }
        if (!store.entityChanged ||
            !!myFilesEntity.length ||
            !store.needsEntityFileUpload) {
            needEntity = false;
        }
        return needBanking || needEntity;
    };
    (0, react_1.useEffect)(() => {
        if (uploadCallback) {
            if (localBankResponse || localFileResponse) {
                uploadCallback({
                    status: submitted,
                    bankResp: localBankResponse,
                    fileResp: localFileResponse,
                    store: store,
                });
            }
        }
    }, [submitted, localBankResponse, localFileResponse]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.H2, { children: store.storeName }), store.bankingChanged && store.needsBankingFileUpload && ((0, jsx_runtime_1.jsxs)("div", { className: `file-box ${errFileBanking ? 'has-file-err' : 'no-file-err'}`, children: [(0, jsx_runtime_1.jsx)(components_1.H3, { variant: "title-large", children: "Banking Proof (Voided check, Bank letter)" }), !myFilesBankingProof.length ? ((0, jsx_runtime_1.jsxs)("div", { ...getRootPropsBankingProof({
                            className: isDragAcceptBankingProof
                                ? 'dropzone accepted'
                                : isDragRejectBankingProof
                                    ? 'dropzone rejected'
                                    : 'dropzone',
                        }), children: [(0, jsx_runtime_1.jsxs)(components_1.Span, { variant: "body-large", children: [(0, jsx_runtime_1.jsxs)(components_1.Span, { variant: "body-large", className: "file-err-msg", children: [errFileBanking ? errFileBanking : `Drop files here or `, ' '] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("input", { className: "hidden", type: "file", name: "bankingProof", accept: ".pdf, .png, .jpg, .jpeg", id: "bankingProof", ...getInputPropsBankingProof() }), (0, jsx_runtime_1.jsx)(components_1.Label, { size: "large", className: "font-bold text-as-link", htmlFor: "bankingProof", children: "click to browse" })] }), (0, jsx_runtime_1.jsx)(components_1.P, { className: "sub-text", children: "Accepted file types: PDF,JPEG, PNG" })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "uploaded-file-container", children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsxs)("div", { className: "file-name-and-close", children: [(0, jsx_runtime_1.jsx)(components_1.P, { children: filesBankingProof[0].key }), !submitted ? ((0, jsx_runtime_1.jsx)("button", { onClick: removeAllBankingProof, disabled: submitting, children: (0, jsx_runtime_1.jsx)("img", { src: garbage_icon_svg_1.default, alt: "Delete file", className: "close-button" }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }), (0, jsx_runtime_1.jsx)("div", { className: "loading-bar" })] }))] })), store.entityChanged && store.needsEntityFileUpload && ((0, jsx_runtime_1.jsxs)("div", { className: `file-box ${errFileEntity ? 'has-file-err' : 'no-file-err'}`, children: [(0, jsx_runtime_1.jsx)(components_1.P, { children: "Entity (W9 or equivalent)" }), !myFilesEntity.length ? ((0, jsx_runtime_1.jsxs)("div", { ...getRootPropsEntity({
                            className: isDragAcceptEntity
                                ? 'dropzone accepted'
                                : isDragRejectEntity
                                    ? 'dropzone rejected'
                                    : 'dropzone',
                        }), children: [(0, jsx_runtime_1.jsxs)(components_1.Span, { variant: "body-large", children: [(0, jsx_runtime_1.jsxs)(components_1.Span, { variant: "body-large", className: "file-err-msg", children: [errFileEntity ? errFileEntity : `Drop files here or `, ' '] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("input", { className: "hidden", type: "file", name: "entity", accept: ".pdf, .png, .jpg, .jpeg", id: "entity", ...getInputPropsEntity() }), (0, jsx_runtime_1.jsx)(components_1.Label, { htmlFor: "entity", size: "large", className: "font-bold text-as-link", children: "click to browse" })] }), (0, jsx_runtime_1.jsx)(components_1.P, { className: "sub-text", children: "Accepted file types: PDF,JPEG, PNG" })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "uploaded-file-container", children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsxs)("div", { className: "file-name-and-close", children: [(0, jsx_runtime_1.jsx)(components_1.P, { children: filesEntity[0].key }), !submitted ? ((0, jsx_runtime_1.jsx)("button", { onClick: removeAllEntity, disabled: submitting, children: (0, jsx_runtime_1.jsx)("img", { src: garbage_icon_svg_1.default, alt: "Delete file", className: "close-button" }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }), (0, jsx_runtime_1.jsx)("div", { className: "loading-bar" })] }))] })), !submitted ? ((0, jsx_runtime_1.jsx)("div", { className: "submitted-container", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", className: "button-warn", onClick: handleSubmit, submitting: submitting, pristine: isPristine(), children: "ATTACH & SUBMIT" }) })) : ((0, jsx_runtime_1.jsxs)("div", { className: "submitted-container", children: [(0, jsx_runtime_1.jsx)("img", { src: complete_check_svg_1.default, className: "success-icon", alt: "Success" }), (0, jsx_runtime_1.jsx)(components_1.P, { children: "Document Uploaded" })] }))] }));
}
function mapStateToProps() {
    return {};
}
const mapApiAuthToProps = {
    uploadDocument: apiActions.uploadDocument,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(StoreDocUploadForm);
